// extracted by mini-css-extract-plugin
module.exports = {"main":"BBPicture_main__1ar9K","list":"BBPicture_list__2NHoR","firstItemBold":"BBPicture_firstItemBold__2GaX7","link":"BBPicture_link__3j9YO"};